<template>
  <footer class="global-footer">
    <div class="footer-content">
      <!-- 商家入驻广告 -->
      <div class="merchant-entry-banner">
        <div class="entry-img-wrap">
          <img src="../assets/images/ruzhu.jpg" class="entry-bg" alt="商家入驻" />
        </div>
        <div class="entry-contact">
          <a v-if="configs.customer_service_phone" :href="'tel:' + configs.customer_service_phone" class="entry-phone">
            <i class="fa-solid fa-phone"></i>
            <span>{{ configs.customer_service_phone }}</span>
          </a>
          <div v-if="configs.customer_service_wechat" class="entry-wechat" @click="showWechatInfo = true">
            <i class="fa-brands fa-weixin"></i>
            <span>联系方式：微信</span>
            <i class="fa-solid fa-chevron-right arrow-icon"></i>
          </div>

          <!-- 微信信息弹窗 -->
          <div v-if="showWechatInfo" class="wechat-modal" @click.self="showWechatInfo = false">
            <div class="wechat-modal-content">
              <button class="wechat-modal-close" @click="showWechatInfo = false">
                <i class="fa-solid fa-xmark"></i>
              </button>
              <div class="wechat-modal-body">
                <div v-if="wechatQrCode" class="wechat-qr-wrapper-top">
                  <img :src="wechatQrCode" alt="微信二维码" class="wechat-qr-img" />
                </div>
                <h3 class="wechat-modal-title">长按上方二维码添加好友</h3>
                <div class="wechat-id-card">
                  <span class="wechat-id-label">微信号</span>
                  <span class="wechat-id-value">{{ configs.customer_service_wechat }}</span>
                  <button class="wechat-copy-btn" @click="copyWechatId">
                    <i class="fa-regular fa-copy"></i>
                    <span>{{ copied ? '已复制' : '复制' }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="configs.site_name" class="footer-brand">
        <img v-if="configs.site_logo" :src="configs.site_logo" class="footer-logo" alt="logo" />
        <span class="footer-name">{{ configs.site_name }}</span>
      </div>

      <div class="footer-links">
        <span class="footer-link" @click="showPrivacy = true">隐私政策</span>
        <span class="footer-divider">|</span>
        <span class="footer-link" @click="showDisclaimer = true">免责说明</span>
      </div>

      <div class="footer-info">
        <p v-if="configs.icp_filing" class="icp">{{ configs.icp_filing }}</p>
        <p v-if="configs.copyright" class="copyright">{{ configs.copyright }}</p>
      </div>

      <!-- 隐私政策弹窗 -->
      <div v-if="showPrivacy" class="modal-overlay" @click.self="showPrivacy = false">
        <div class="modal-content">
          <div class="modal-header">
            <h3>隐私政策</h3>
            <button class="modal-close" @click="showPrivacy = false">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
          <div class="modal-body markdown-body" v-html="privacyHtml"></div>
          <div class="modal-footer">
            <button class="modal-btn" @click="showPrivacy = false">我知道了</button>
          </div>
        </div>
      </div>

      <!-- 免责说明弹窗 -->
      <div v-if="showDisclaimer" class="modal-overlay" @click.self="showDisclaimer = false">
        <div class="modal-content">
          <div class="modal-header">
            <h3>免责说明</h3>
            <button class="modal-close" @click="showDisclaimer = false">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
          <div class="modal-body markdown-body" v-html="disclaimerHtml"></div>
          <div class="modal-footer">
            <button class="modal-btn" @click="showDisclaimer = false">我知道了</button>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { marked } from 'marked'
import wechatQrCode from '../assets/wechat.png'

export default {
  name: 'GlobalFooter',
  props: {
    configs: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showWechatInfo: false,
      wechatQrCode,
      copied: false,
      showPrivacy: false,
      showDisclaimer: false
    }
  },
  computed: {
    privacyHtml() {
      const content = this.configs.privacy_statement || '平台仅为完成信息发布必要范围内使用数据，**不存储、不私自拷贝、跨方读取用户隐私信息**，未经授权不向第三方泄露用户隐私。'
      return marked(content)
    },
    disclaimerHtml() {
      const content = this.configs.disclaimer || '平台内容仅用于公益展示、信息发布，不提供商业补贴，不担保商家履约；用户与合作方自行开展交易产生的消费纠纷、售后损失，平台不承担赔付及连带责任。\n\n**使用本服务即视为同意本声明。**'
      return marked(content)
    }
  },
  methods: {
    async copyWechatId() {
      try {
        await navigator.clipboard.writeText(this.configs.customer_service_wechat)
        this.copied = true
        setTimeout(() => { this.copied = false }, 2000)
      } catch (e) {
        // fallback
        const input = document.createElement('input')
        input.value = this.configs.customer_service_wechat
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)
        this.copied = true
        setTimeout(() => { this.copied = false }, 2000)
      }
    }
  }
}
</script>

<style scoped>
.global-footer {
  color: #9ca3af;
  padding: 24px 16px;
  margin-bottom: 100px;
  background: #ecf2fb;
}

.footer-content {
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
}

/* 商家入驻广告 */
.merchant-entry-banner {
  position: relative;
  border-radius: 16px;
  margin-bottom: 16px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.merchant-entry-banner::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
    45deg,
    transparent 30%,
    rgba(255, 255, 255, 0.4) 50%,
    transparent 70%
  );
  transform: translateX(-100%);
  animation: shine 3s infinite;
  z-index: 10;
  pointer-events: none;
}

@keyframes shine {
  0% { transform: translateX(-100%) rotate(45deg); }
  100% { transform: translateX(100%) rotate(45deg); }
}

.entry-img-wrap {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.entry-img-wrap::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 40%;
  background: linear-gradient(transparent, rgba(255, 107, 53, 0.1));
  pointer-events: none;
}

.entry-bg {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
  transition: transform .5s;
}

.merchant-entry-banner:active .entry-bg {
  transform: scale(1.02);
}

.entry-contact {
  position: relative;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: linear-gradient(135deg, #fff9f0 0%, #fff 100%);
}

.entry-contact::before {
  content: '';
  position: absolute;
  top: 0;
  left: 16px;
  right: 16px;
  height: 1px;
  background: linear-gradient(90deg, transparent, #ffb347, transparent);
}

.entry-phone {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: linear-gradient(135deg, #ff6b35 0%, #f7931e 100%);
  color: #fff;
  padding: 14px 20px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
  box-shadow: 0 4px 12px rgba(255, 107, 53, 0.3);
  transition: transform .2s, box-shadow .2s;
  overflow: hidden;
}

.entry-phone::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  transition: left .5s;
}

.entry-phone:hover::before {
  left: 100%;
}

.entry-phone:active {
  transform: scale(0.97);
  box-shadow: 0 2px 8px rgba(255, 107, 53, 0.4);
}

.entry-phone i {
  font-size: 18px;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

.entry-wechat {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
  padding: 10px 16px;
  cursor: pointer;
  transition: all 0.2s;
  background: linear-gradient(135deg, #f0fdf4, #dcfce7);
  border: 1px solid #bbf7d0;
  border-radius: 10px;
}

.entry-wechat:active {
  opacity: 0.7;
  transform: scale(0.98);
}

.entry-wechat i {
  color: #07c160;
  font-size: 20px;
}

.entry-wechat .arrow-icon {
  color: #86efac;
  font-size: 12px;
  margin-left: auto;
}

.footer-brand {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 12px;
}

.footer-logo {
  width: 20px;
  height: 20px;
  border-radius: 4px;
}

.footer-name {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.footer-info {
  padding-top: 12px;
  border-top: 1px solid #f3f4f6;
}

.icp {
  font-size: 11px;
  color: #9ca3af;
  margin-bottom: 2px;
}

.copyright {
  font-size: 10px;
  color: #d1d5db;
}

/* 底部链接 */
.footer-links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 12px;
}

.footer-link {
  font-size: 12px;
  color: #6b7280;
  cursor: pointer;
  transition: color 0.2s;
}

.footer-link:active {
  color: #2563eb;
}

.footer-divider {
  font-size: 10px;
  color: #d1d5db;
}

/* 弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
  animation: fadeIn 0.2s ease;
}

.modal-content {
  background: #fff;
  border-radius: 16px;
  width: 100%;
  max-width: 320px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f3f4f6;
}

.modal-header h3 {
  font-size: 16px;
  font-weight: 700;
  color: #1f2937;
}

.modal-close {
  width: 28px;
  height: 28px;
  border: none;
  background: rgba(0, 0, 0, 0.06);
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.modal-close:active {
  background: rgba(0, 0, 0, 0.1);
}

.modal-close i {
  font-size: 14px;
  color: #666;
}

.modal-body {
  padding: 20px;
}

.modal-body p {
  font-size: 14px;
  color: #4b5563;
  line-height: 1.8;
  margin-bottom: 12px;
}

.modal-body p:last-child {
  margin-bottom: 0;
}

.modal-body strong {
  color: #1f2937;
  font-weight: 600;
}

/* Markdown 样式 */
.markdown-body {
  font-size: 14px;
  color: #4b5563;
  line-height: 1.8;
}

.markdown-body h1,
.markdown-body h2,
.markdown-body h3,
.markdown-body h4 {
  margin: 16px 0 8px;
  font-weight: 600;
  color: #1f2937;
}

.markdown-body h1 { font-size: 20px; }
.markdown-body h2 { font-size: 18px; }
.markdown-body h3 { font-size: 16px; }
.markdown-body h4 { font-size: 14px; }

.markdown-body p {
  margin: 8px 0;
}

.markdown-body ul,
.markdown-body ol {
  padding-left: 20px;
  margin: 8px 0;
}

.markdown-body li {
  margin: 4px 0;
}

.markdown-body strong {
  color: #1f2937;
  font-weight: 600;
}

.markdown-body em {
  font-style: italic;
}

.markdown-body blockquote {
  border-left: 3px solid #2563eb;
  padding-left: 12px;
  margin: 8px 0;
  color: #6b7280;
}

.modal-footer {
  padding: 16px 20px;
  border-top: 1px solid #f3f4f6;
}

.modal-btn {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #2563eb, #3b82f6);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s, opacity 0.2s;
}

.modal-btn:active {
  transform: scale(0.98);
  opacity: 0.9;
}

/* 微信信息弹窗 */
.wechat-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.2s ease;
  padding: 20px;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.wechat-modal-content {
  background: #fff;
  border-radius: 16px;
  width: 100%;
  max-width: 300px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease;
  position: relative;
}

@keyframes slideUp {
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.wechat-modal-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 28px;
  height: 28px;
  border: none;
  background: rgba(0, 0, 0, 0.06);
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  z-index: 2;
}

.wechat-modal-close:hover {
  background: rgba(0, 0, 0, 0.1);
}

.wechat-modal-close i {
  font-size: 14px;
  color: #666;
}

.wechat-modal-body {
  padding: 28px 24px 24px;
  text-align: center;
}

.wechat-modal-title {
  font-size: 17px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 14px;
}

.wechat-id-card {
  background: linear-gradient(135deg, #f0fdf4, #dcfce7);
  border: 1px solid #bbf7d0;
  border-radius: 10px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.wechat-id-label {
  font-size: 16px;
  color: #16a34a;
  font-weight: 700;
}

.wechat-id-value {
  font-size: 16px;
  font-weight: 700;
  color: #15803d;
  letter-spacing: 0.5px;
}

.wechat-copy-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 8px 16px;
  border: none;
  border-radius: 16px;
  background: linear-gradient(135deg, #07c160, #06ad56);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 2px;
}

.wechat-copy-btn:active {
  transform: scale(0.96);
  opacity: 0.9;
}

.wechat-copy-btn i {
  font-size: 13px;
}

.wechat-qr-wrapper-top {
  margin-bottom: 14px;
}

.wechat-qr-wrapper-top img {
  width: 160px;
  height: 160px;
  object-fit: contain;
  display: block;
  margin: 0 auto;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  padding: 8px;
}
</style>
